<template>
    <div class='separator'></div>
</template>

<style lang="scss">
.separator{
    height: 1px;
    width: 100%;
    background-color: #DDDBDC;
}
</style>